import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-5/6 h-[100vh] p-[2%]" }
const _hoisted_2 = { class: "md:flex h-full" }
const _hoisted_3 = { class: "md:w-3/12" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "font-bold mr-1" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "font-bold mr-1" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "font-bold mr-1" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "font-bold mr-1" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "font-bold mr-1" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "font-bold mr-1" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "font-bold mr-1" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "font-bold mr-1" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "font-bold mr-1" }
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = { class: "font-bold mr-1" }
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "font-bold mr-1" }
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = { class: "font-bold mr-1" }
const _hoisted_28 = { class: "md:w-6/12 grid justify-center items-center text-center justify-items-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold ml-4 text-xl" }, "Tetti", -1)
const _hoisted_30 = { class: "md:w-3/12" }
const _hoisted_31 = { class: "flex" }
const _hoisted_32 = { class: "font-bold mr-1" }
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = { class: "font-bold mr-1" }
const _hoisted_35 = { class: "flex" }
const _hoisted_36 = { class: "font-bold mr-1" }
const _hoisted_37 = { class: "flex" }
const _hoisted_38 = { class: "font-bold mr-1" }
const _hoisted_39 = { class: "flex" }
const _hoisted_40 = { class: "font-bold mr-1" }
const _hoisted_41 = { class: "flex" }
const _hoisted_42 = { class: "font-bold mr-1" }
const _hoisted_43 = { class: "flex" }
const _hoisted_44 = { class: "font-bold mr-1" }
const _hoisted_45 = { class: "flex" }
const _hoisted_46 = { class: "font-bold mr-1" }
const _hoisted_47 = { class: "flex" }
const _hoisted_48 = { class: "font-bold mr-1" }
const _hoisted_49 = { class: "flex" }
const _hoisted_50 = { class: "font-bold mr-1" }

import BuildingCarousel from "@/components/building/view/components/BuildingCarousel.vue";
import {Card, CardContent, CardHeader, CardTitle} from "@/components/ui/card";
import {onMounted, ref} from "vue";
import TablesService from "@/services/tables/tables.service";
import {useRoute} from "vue-router";
import BuildingRoofCarousel from "@/components/building/view/components/BuildingRoofCarousel.vue";
import {File, FilePlus} from "lucide-vue-next";
import {Button} from "@/components/ui/button";
import UploadDocumentDialog from "@/components/building/UploadDocumentDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewBuilding',
  setup(__props) {

const route = useRoute();
let loading = ref(true);
let building: any = ref({})
const isDocumentDialogOpen = ref(false);

const setIsDocumentDialogOpen = (value: boolean) => {
  isDocumentDialogOpen.value = value;
};

onMounted(async () => {
  const res = await TablesService.getElementById('buildings', route.params.id)
  if (res?.data) {
    building.value = res.data
    loading.value = false;
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Card), { class: "h-[50%]" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardHeader), { class: "p-5 bg-gray-400" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardTitle), { class: "text-lg" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('building.master')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(CardContent), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('column.name')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).master?.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('column.code')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).master?.code), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('column.address')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).master?.address), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('column.zip')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).master?.zip), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('column.city')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).master?.city), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('column.state')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).master?.state), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(Card), { class: "mt-4 h-[50%]" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardHeader), { class: "p-5 bg-gray-400" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardTitle), { class: "text-lg" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('building.manager')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(CardContent), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('column.name')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).manager?.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('column.code')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).manager?.code), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('column.address')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).manager?.address), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('column.zip')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).manager?.zip), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('column.city')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).manager?.city), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('column.state')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).manager?.state), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(BuildingCarousel, {
            entity: "buildings",
            "entity-id": _unref(route).params.id as string
          }, null, 8, ["entity-id"]),
          _hoisted_29,
          (_unref(loading) === false)
            ? (_openBlock(), _createBlock(BuildingRoofCarousel, {
                key: 0,
                entity: "coverages",
                data: _unref(building).roofings
              }, null, 8, ["data"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_unref(Card), { class: "h-full" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardHeader), { class: "p-5 bg-gray-400" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardTitle), { class: "text-lg" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('building.info')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(CardContent), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t('column.name')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('column.code')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).code), 1)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t('column.address')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).address), 1)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t('column.zip')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).zip), 1)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t('column.city')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).city), 1)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t('column.state')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).state), 1)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t('column.yearConstruction')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).yearConstruction), 1)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.$t('column.sustainability')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).buildingSustainability), 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t('column.description')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).description), 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.$t('column.activity')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(building).activity), 1)
                    ]),
                    _createVNode(_unref(Button), {
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'documentsView', params: { entity:'buildings', id: _unref(building).id } })), ["prevent"])),
                      type: "button",
                      class: "w-full text-center mt-6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(File), { class: "mr-2 h-5 w-5" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('building.document_gallery')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), {
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (setIsDocumentDialogOpen(true)), ["prevent"])),
                      type: "button",
                      class: "w-full text-center mt-6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FilePlus), { class: "mr-2 h-5 w-5" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('building.add_document')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(UploadDocumentDialog, {
      entity: "buildings",
      "entity-id": _unref(route).params.id,
      open: isDocumentDialogOpen.value,
      "set-open": setIsDocumentDialogOpen,
      onEdit: _cache[2] || (_cache[2] = ($event: any) => (setIsDocumentDialogOpen(false)))
    }, null, 8, ["entity-id", "open"])
  ], 64))
}
}

})